import { Input } from "@/components/ui/input";
import React from "react";
import { useNavigate } from "react-router-dom";

export interface OperationItem {
  title: string;
  description: string;
  image: string;
  route: string;
}

type ToolbarProps = object;

interface ItemCardProps {
  item: OperationItem;
}

const ItemCard: React.FC<ItemCardProps> = ({ item }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(item.route);
  };

  return (
    <div
      className="rounded-lg border bg-white shadow-sm cursor-pointer hover:shadow-md transition-shadow"
      onClick={handleClick}
    >
      <div className="relative h-48 mb-4 rounded-t-lg overflow-hidden">
        <img
          src={item.image}
          alt="Course cover"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-transparent to-black opacity-50"></div>
      </div>
      <div className="p-6">
        <div className="mb-4 flex items-center justify-between">
          <h3 className="text-lg font-semibold">{item.title}</h3>
        </div>
        <p className="text-neutral-600 mb-4">{item.description}</p>
      </div>
    </div>
  );
};

const Toolbar: React.FC<ToolbarProps> = () => (
  <section id="tools" className="mb-6">
    <div className="flex flex-wrap items-center justify-between gap-4">
      <div className="flex flex-1 items-center space-x-4">
        <div className="relative flex-1 max-w-xl">
          <Input
            type="search"
            placeholder="Search items..."
            className="pl-10"
          />
          <i className="fa-solid fa-search absolute left-3 top-1/2 -translate-y-1/2 text-neutral-400"></i>
        </div>
        <button className="flex items-center space-x-2 rounded-lg border border-neutral-300 px-4 py-2">
          <i className="fa-solid fa-filter text-neutral-600"></i>
          <span>Filters</span>
        </button>
      </div>
    </div>
  </section>
);

interface OpListProps {
  items: OperationItem[];
}

export const OperationsList: React.FC<OpListProps> = ({ items }) => {
  return (
    <main id="main" className="py-6">
      <Toolbar />
      <section
        id="items-grid"
        className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3"
      >
        {items.map((item, index) => (
          <ItemCard key={index} item={item} />
        ))}
      </section>
    </main>
  );
};
